export const generateCodeSnippet = (knobs, selector, children) => {
  const knobTemplate = (acc, key, value) => `${acc} \n [${key}]="${value}"`;
  const isArrayOfStrings = value => Array.isArray(value) && typeof value[0] === 'string';
  const stringifyObject = value => JSON.stringify(value).replace(/"/gi, `'`);

  const validKnobs = Object.entries(knobs).reduce((validKnobsAcc, [knobKey, knobValue]) => {
    const knobName = knobKey.indexOf('_') > -1 ? knobKey.slice(0, knobKey.indexOf('_')) : knobKey;
    let value = knobValue;
    if (typeof value === 'string') {
      value = `'${value}'`;
    } else if (isArrayOfStrings(value)) {
      value = `'${value.join(' ')}'`;
    } else if (typeof value === 'object') {
      value = stringifyObject(value);
    }
    return knobTemplate(validKnobsAcc, knobName, value);
  }, '');
  return `<${selector}${validKnobs}>${children}\n</${selector}>`.trim();
};
